export const contactData = [
  {
    id: 1,
    si_no: "",
    select: "",
    customer_name: "Darlee Robertson",
    isVerified:true,
    customer_image: "assets/img/profiles/avatar-26.jpg",
    customer_no: "Team Lead Dev",
    phone: "0987654321",
    email: "jonathan@example.com",
    customer_occupation:'Marketing Head',
    dateCreated:"15 Sept 2024",
    location: "India",
    customer_company:"Google",
    customer_tag: "Collab",
    rating: "2.7",
    owner: "Theresa",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "1",
  },
  {
    id: 2,
    si_no: "",
    select: "",
    customer_name: "Sharon Roy",
    customer_image: "assets/img/profiles/avatar-20.jpg",
    customer_no: "Installer",
    isVerified:true,
    customer_company:"Meta",
    customer_occupation:'General Manager',
    dateCreated:"15 Sept 2024",
    phone: "+1 989757485",
    email: "sharon@example.com",
    location: "USA",
    customer_tag: "",
    rating: "5.0",
    owner: "Guillory",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Inactive",
    Action: "",
    key: "2",
  },
  {
    id: 3,
    si_no: "",
    select: "",
    customer_name: "Vaughan",
    customer_image: "assets/img/profiles/avatar-21.jpg",
    dateCreated:"15 Sept 2024",
    customer_no: "Senior  Manager",
    phone: "+1 546555455",
    isVerified:false,
    email: "vaughan12@example.com",
    customer_occupation:'General Manager',
    location: "Canada",
    customer_tag: "Collab",
    customer_company:"Google",
    rating: "3.5",
    owner: "Jami",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "3",
  },
  {
    id: 4,
    si_no: "",
    select: "",
    customer_name: "Jessica",
    customer_image: "assets/img/profiles/avatar-23.jpg",
    dateCreated:"15 Sept 2024",
    customer_no: "Test Engineer",
    isVerified:false,
    phone: "+1 454478787",
    email: "jessica13@example.com",
    location: "India",
    customer_company:"Microsoft",
    customer_occupation:'Sales Executive',
    customer_tag: "Rated",
    rating: "4.5",
    owner: "Theresa",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "4",
  },
  {
    id: 5,
    si_no: "",
    select: "",
    customer_name: "Carol Thomas",
    isVerified:true,
    customer_image: "assets/img/profiles/avatar-16.jpg",
    dateCreated:"15 Sept 2024",
    customer_no: "UI /UX Designer",
    phone: "+1 124547845",
    customer_occupation:'Sales Executive',
    email: "caroltho3@example.com",
    location: "China",
    customer_company:"Oracle",
    customer_tag: "Collab",
    rating: "4.7",
    owner: "",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "5",
  },
  {
    id: 6,
    si_no: "",
    select: "",
    customer_name: "Dawn Mercha",
    customer_image: "assets/img/profiles/avatar-22.jpg",
    dateCreated:"15 Sept 2024",
    customer_no: "Technician",
    phone: "+1 478845447",
    isVerified:false,
    customer_occupation:'Developer',
    email: "dawnmercha@example.com",
    location: "Japan",
    customer_company:"Meta",
    customer_tag: "",
    rating: "5.0",
    owner: "Guillory",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "6",
  },
  {
    id: 7,
    si_no: "",
    select: "",
    customer_name: "Rachel Hampton",
    customer_image: "assets/img/profiles/avatar-24.jpg",
    dateCreated:"15 Sept 2024",
    customer_no: "Software Developer",
    phone: "+1 215544845",
    isVerified:false,
    email: "rachel@example.com",
    customer_occupation:'Developer',
    location: "Indonesia",
    customer_tag: "Promotion",
    customer_company:"Oracle",
    rating: "3.1",
    owner: "Jami",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "7",
  },
  {
    id: 8,
    si_no: "",
    select: "",
    customer_name: "Jonelle Curtiss",
    customer_image: "assets/img/profiles/avatar-25.jpg",
    customer_no: "Supervisor",
    phone: "+1 121145471",
    isVerified:true,
    dateCreated:"15 Sept 2024",
    email: "jonelle@example.com",
    customer_occupation:'Sales Executive',
    location: "Cuba",
    customer_tag: "Rated",
    customer_company:"Meta",
    rating: "5.0",
    owner: "Theresa",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "8",
  },
  {
    id: 9,
    si_no: "",
    select: "",
    customer_name: "Jonathan",
    customer_image: "assets/img/profiles/avatar-26.jpg",
    customer_no: "Team Lead Dev",
    phone: "+1 321454789",
    email: "jonathan@example.com",
    customer_occupation:'Marketing Head',
    dateCreated:"15 Sept 2024",
    location: "Isreal",
    isVerified:true,
    customer_company:"Google",
    customer_tag: "Collab",
    rating: "2.7",
    owner: "Theresa",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "9",
  },
  {
    id: 10,
    si_no: "",
    select: "",
    customer_name: "Brook",
    customer_image: "assets/img/profiles/avatar-01.jpg",
    customer_no: "Team Lead Dev ",
    phone: "+1 278907145",
    customer_occupation:'Marketing Head',
    email: "brook@example.com",
    location: "Colombia",
    isVerified:false,
    dateCreated:"15 Sept 2024",
    customer_tag: "Promotion",
    customer_company:"Netflix",
    rating: "3.0",
    owner: "Espinosa",
    owner_image: "assets/img/profiles/avatar-14.jpg",
    status: "Active",
    Action: "",
    key: "10",
  },
];
